// hooks/useMyAttendanceByModule.js
import { useEffect, useMemo, useState } from "react";
import { getMyAttendance } from "../service/attendance.simple";

export function useMyAttendanceByModule(uid, trainerIds = [], batchId) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!uid) {
      setRows([]);
      return;
    }
    let alive = true;

    // If trainerIds is empty, fetch ALL (don’t block)
    const filter =
      Array.isArray(trainerIds) && trainerIds.length > 0
        ? trainerIds
        : undefined;

    getMyAttendance(uid, filter, { debug: true }, batchId)
      .then((r) => alive && setRows(r))
      .catch(() => alive && setRows([]));

    return () => {
      alive = false;
    };
  }, [uid, JSON.stringify(trainerIds)]);

  const byModule = useMemo(() => {
    const map = {};
    (rows || []).forEach((r) => {
      const mid = r.moduleId;
      if (!mid) return;

      if (!map[mid]) {
        map[mid] = {
          present: 0,
          absent: 0,
          total: 0,
          lastStatus: "not_marked",
          lastAt: -1,
        };
      }

      const isReal =
        r.attendanceStatus === "present" || r.attendanceStatus === "absent";
      const ts = r.updatedAt?.seconds ?? r.updatedAtSeconds ?? 0;

      if (r.attendanceStatus === "present") map[mid].present += 1;
      if (r.attendanceStatus === "absent") map[mid].absent += 1;
      if (isReal) map[mid].total += 1; // only count real marks

      // Prefer newer timestamps; if same timestamp, prefer a real mark
      if (
        ts > map[mid].lastAt ||
        (ts === map[mid].lastAt &&
          isReal &&
          map[mid].lastStatus === "not_marked")
      ) {
        map[mid].lastAt = ts;
        map[mid].lastStatus = isReal ? r.attendanceStatus : map[mid].lastStatus;
      }
    });

    Object.values(map).forEach((v) => {
      v.pct = v.total ? Math.round((v.present / v.total) * 100) : 0;
    });
    return map;
  }, [rows]);

  const totals = useMemo(() => {
    let present = 0,
      absent = 0;
    (rows || []).forEach((r) => {
      if (r.attendanceStatus === "present") present += 1;
      if (r.attendanceStatus === "absent") absent += 1;
    });
    const total = present + absent;
    const pct = total ? Math.round((present / total) * 100) : 0;
    return { present, absent, total, pct };
  }, [rows]);

  return { loading: rows === null, byModule, totals };
}
